import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Skeleton,
} from "@material-ui/core";
import axios from "axios";
import { FaSquarePlus, FaSquareMinus } from "react-icons/fa6";


const PendingInvoiceTableA2 = ({ setData, data }) => {
  const [sumInv, setSumInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  function categorizeInvoices(invoices, catWith) {
    const categorizedInvoices = {};
    invoices.forEach((invoice) => {
      const category = invoice[catWith];
      if (!categorizedInvoices[category]) {
        categorizedInvoices[category] = {
          name: category,
          data: [],
          isOpen: false,
          count: 0,
        };
      }
      categorizedInvoices[category]?.data?.push(invoice);
      categorizedInvoices[category].count += 1;
    });

    return categorizedInvoices;
  }

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/PendingInvoicesA2`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      const responseData = res?.data?.response || [];
      const categorizedProducts = categorizeInvoices(responseData, "pendingWith");

      Object?.keys(categorizedProducts)?.forEach((key) => {
        const item = categorizedProducts[key];
        const categorizedProductseWithPersonName = categorizeInvoices(item?.data, "personName");

        Object?.keys(categorizedProductseWithPersonName).forEach((key) => {
          const item = categorizedProductseWithPersonName[key];
          const categorizedProductseWithSubmittedBy = categorizeInvoices(item?.data, "submittedBy");

          Object?.keys(categorizedProductseWithSubmittedBy)?.forEach((key) => {
            const item = categorizedProductseWithSubmittedBy[key];
            const categorizedProductseWithVendorName = categorizeInvoices(item?.data, "vendorName");
            categorizedProductseWithSubmittedBy[key].data = categorizedProductseWithVendorName;
          });
          categorizedProductseWithPersonName[key].data = categorizedProductseWithSubmittedBy;
        });
        categorizedProducts[key].data = categorizedProductseWithPersonName;
      });

      setData(categorizedProducts);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const calculateGrandTotal = (data) => {
    let total = 0;
    Object.keys(data).forEach((key) => {
      total += data[key].count;
    });
    setSumInvoice(total);
  };

  useEffect(() => {
    if (!isLoading) {
      calculateGrandTotal(data);
    }
  }, [isLoading, data]);

  const expandHandler = (expandedState, level, obj) => {
    const tempData = { ...data };
    if (level === "pendingWith") {
      tempData[obj.pendingWith].isOpen = !expandedState;
    }
    if (level === "personName") {
      tempData[obj.pendingWith].data[obj.personName].isOpen = !expandedState;
    }
    if (level === "submittedBy") {
      tempData[obj.pendingWith].data[obj.personName].data[obj.submittedBy].isOpen = !expandedState;
    }
    if (level === "vendorName") {
      tempData[obj.pendingWith].data[obj.personName].data[obj.submittedBy].data[obj.vendorName].isOpen = !expandedState;
    }
    setData(tempData);
  };

  const renderRows = (data, level, parentKeys = {}) => {
    return Object.keys(data).map((key) => {
      const item = data[key];
      const currentKeys = { ...parentKeys, [level]: key };

      return (
        <React.Fragment key={key}>
          <TableRow style={{ paddingTop: 0, }}>
            {level === "pendingWith" && (
              <>
                <TableCell
                  style={{ verticalAlign: "baseline", cursor: "pointer" }}
                  onClick={() => expandHandler(item.isOpen, level, currentKeys)}
                >
                  {item.isOpen ? <FaSquareMinus size={20} color="#c7d2d6" /> : <FaSquarePlus color="#0095DA" size={20} />} {key}
                </TableCell>
                <TableCell colSpan={3}>
                  {item.isOpen && renderRows(item.data, "personName", currentKeys)}
                </TableCell>
                <TableCell align="right">
                  {!item.isOpen && item.count}
                </TableCell>
              </>
            )}
            {level === "personName" && (
              <>
                <TableCell
                  style={{ verticalAlign: "baseline", paddingLeft: "20px", cursor: "pointer", paddingTop: 0, width: "200px" }}
                  onClick={() => expandHandler(item.isOpen, level, currentKeys)}
                  sx={{ border: 0 }}
                >
                  {item.isOpen ? <FaSquareMinus size={20} color="#c7d2d6" /> : <FaSquarePlus size={20} color="#0095DA" />} {key}
                </TableCell>
                <TableCell colSpan={2} sx={{ border: 0 }}>
                  {item.isOpen && renderRows(item.data, "submittedBy", currentKeys)}
                </TableCell>
                <TableCell align="center" sx={{ border: 0 }} colSpan={6} style={{ verticalAlign: "baseline", paddingLeft: "60px", paddingTop: 0, position: "absolute", right: 0 }}>
                  {!item.isOpen && item.count}
                </TableCell>
              </>
            )}
            {level === "submittedBy" && (
              <>
                <TableCell
                  style={{ verticalAlign: "baseline", paddingLeft: "100px", cursor: "pointer", paddingTop: 0, width: "200px" }}
                  onClick={() => expandHandler(item.isOpen, level, currentKeys)}
                  sx={{ border: 0 }}
                >
                  {item.isOpen ? <FaSquareMinus size={20} color="#c7d2d6" /> : <FaSquarePlus size={20} color="#0095DA" />} {key}
                </TableCell>
                <TableCell sx={{ border: 0 }}>
                  {item.isOpen && renderRows(item.data, "vendorName", currentKeys)}
                </TableCell>
                <TableCell sx={{ border: 0 }} align="center" style={{ verticalAlign: "baseline", paddingLeft: "60px", paddingTop: 0, position: "absolute", right: 0 }}>
                  {!item.isOpen && item.count}
                </TableCell>
              </>
            )}
            {level === "vendorName" && (
              <>

                <TableCell style={{ verticalAlign: "baseline", paddingTop: 0, paddingLeft: "100px", width: "200px" }} sx={{ border: 0 }}>
                  {key}
                </TableCell>
                <TableCell align="center" sx={{ border: 0 }} style={{ verticalAlign: "baseline", paddingTop: 0, position: "absolute", right: 0, }}>{item.count}</TableCell>
              </>
            )}
          </TableRow>
        </React.Fragment>
      );
    });
  };
  return (
    <Table style={{ width: "100%" }}>
      <TableHead>
        <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
          <TableCell >Pending With</TableCell>
          <TableCell style={{ width: "300px" }}>Person Name</TableCell>
          <TableCell style={{ width: "300px" }}>Submitted By</TableCell>
          <TableCell align="start" style={{ width: "300px" }}>Vendor Name</TableCell>
          <TableCell align="center">Count of Invoice_No</TableCell>
        </TableRow>
      </TableHead>
      {isLoading ? (
        <TableBody>
          {Array.from({ length: 6 }, (_, index) => (
            <TableRow key={index} sx={{ borderBottom: "2px solid #D3D3D3 " }}>
              <TableCell>
                <Skeleton variant="rectangular" style={{ height: 48, marginBottom: "10px" }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" style={{ height: 48, marginBottom: "10px" }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" style={{ height: 48, marginBottom: "10px" }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" style={{ height: 48, marginBottom: "10px" }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" style={{ height: 48, marginBottom: "10px" }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      ) : (
        <TableBody style={{ position: "relative" }}>
          {renderRows(data, "pendingWith")}
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Grand Total</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell align="right" style={{ fontWeight: "bold" }}>{sumInv}</TableCell>
          </TableRow>
        </TableBody>
      )}
    </Table>
  );
};

export default PendingInvoiceTableA2;
